<template lang="html">
<div>
     <div class="c-body">
         <div class="album-text" @click="goAlbum" v-show="getFooterShow!==1">
              <div class="block-ttl">所属专辑</div>
              <div class="album-content">
                   <div class="am-imgs">
                         <img :src="albumDat.coverImage" alt="">
                   </div>
                   <div class="am-body">
                        <div class="am-name">{{albumDat.firstTitle}}</div>
                        <div class="am-items">
                            <span>{{albumDat.speed}}</span>
                            <span>{{albumDat.publish}}</span>
                            <span>{{albumDat.publishYears}}</span>
                        </div>
                   </div>
              </div>
         </div>
         <Albumlist :listDat="albumList" :albumId="albumDat.id" @goFreash="goFreash" />

     </div>
</div>
</template>

<script>
import Albumlist from "./albumList";
export default {
    props:['albumDat','albumList','getFooterShow'],
    components:{
        Albumlist
    },
    data(){
        return{

        }
    },
    methods:{
        goFreash:function(e){
             this.$emit('goFreash',e);
        },
        goAlbum:function(){
             this.push({
                 path:'album',
                 query:{
                     iab:this.albumDat.id
                 }
             })
        }
    },
    mounted() {
        window.console.log(this.albumList)
    }
}
</script>

<style lang="css" scoped>


.c-body{
    background: white;
}

.album-content{
    display: flex;
    align-items: center;
    margin: 0 10px;
}

.album-content .am-imgs{
    width: 75px;
    height: 75px;
    border-radius: 3px;
    background: #efefef;
    margin: 12px 0;
}

.album-content .am-imgs img{
   width: 75px;
   height: 75px;
}

.album-content .am-body{
    margin-left: 10px;
}

.album-content .am-body .am-items{
    margin-top: 9px;
}

.album-content .am-body .am-items span{
    font-size: 14px;
    color: #999999;
    margin-right: 9px;
}

.block-ttl{
    margin: 0 10px;
    padding-top: 18px;
    font-weight: bold;
}

</style>
